module.exports = __webpack_public_path__ + "static/homepage-m-41b697b2d91b752ebd072ce741bd6382.png";